import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FeatureModulesRoutingModule } from './feature-modules-routing.module';
import { SharedModule } from '../shared/shared.module';
import { allComponents } from './all.exports';
import { ExternalLibrariesModule } from '../external-libraries/external-libraries.module';

@NgModule({
  declarations: [
    ...allComponents
  ],
  imports: [
    CommonModule,
    FeatureModulesRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    ExternalLibrariesModule
  ]
})
export class FeatureModulesModule { }
